import React, { Component } from "react";
import PropTypes from "prop-types";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import FlexView from "react-flexview";
import SimpleDate from "../../../../modules/SimpleDate";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import moment from "moment";

class PaymentReportFilterModal extends Component {
  constructor(props) {
    super(props);
    this.title = this.props.type === 'bank' ? 'Bank' : "Kas"
    this.state = {
      error: {
        startDate: null,
        endDate: null,
        ddl: null,
      },
    };
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.visible && this.props.visible) {
      this.setState({ error: {} });
      this.resetField();
    }
  }

  componentDidMount() { 
      this.setState({ error: {} });
      this.resetField();
   }

  validate = () => {
    const { startDate, endDate, ddl } = this.props;
    const requiredFields = { startDate, endDate, ddl };

    const error = {};

    Object.entries(requiredFields).forEach(([key, value]) => {
      if (value == null || value === "") {
        error[key] = "Field Wajib Diisi";
      }
    });

    // if (startDate && endDate && new Date(startDate) > new Date(endDate)) {
    //   error.endDate = "Tanggal akhir harus setelah tanggal mulai";
    // }

    const isValid = Object.keys(error).length === 0;

    if (!isValid) {
      this.setState({ error });
    }

    return isValid;
  };

  handlePrint = () => {
    if (this.validate()) {
      this.props.onPrint();
    }
  };

  handleDateChange = (name, value) => {
    if (this.state.error[name]) {
      this.setState((prevState) => ({
        error: {
          ...prevState.error,
          [name]: null,
        },
      }));
    }
    this.props.onValueChange(name, moment(value).format('DD-MM-YYYY'));
  };

  handleDDLChange = (name, value) => {
    if (this.state.error[name]) {
      this.setState((prevState) => ({
        error: {
          ...prevState.error,
          [name]: null,
        },
      }));
    }
    this.props.onValueChange(name, value);
  };

  resetField = () => {
    this.props.onValueChange("startDate", null);
    this.props.onValueChange("endDate", null);
    this.props.onValueChange("ddl", null);
  };

  render() {
    const {
      visible,
      onClickClose,
      startDateName,
      startDate,
      endDate,
      endDateName,
      ddl,
      ddlData
    } = this.props;
    const { error } = this.state;

    const hasDateError = error.startDate || error.endDate;
    return (
      <SimpleModal
        title={`Cetak Laporan Harian ${this.title?.toUpperCase()}`}
        visible={visible}
        onClickClose={onClickClose}
        styles={{ width: "55%" }}
        content={
          <ModalContainer>
            <FlexView style={{ gap: "12px", alignItems: "flex-end" }}>
              <SimpleDate
                label="Tanggal Realisasi"
                id="select_start_date_payment_report_filter"
                nextdate
                name={startDateName}
                date={startDate}
                mandatory
                maxDate={endDate}
                errorMessage={error.startDate}
                onChange={(value) =>
                  this.handleDateChange(startDateName, value)
                }
              />
              <span
                style={{
                  marginBottom: hasDateError ? "55px" : "30px",
                }}
              >
                s/d
              </span>
              <SimpleDate
                id="select_end_date_payment_report_filter"
                nextdate
                name={endDateName}
                date={endDate}
                mandatory
                minDate={startDate}
                errorMessage={error.endDate}
                onChange={(value) => this.handleDateChange(endDateName, value)}
              />
            </FlexView>

            <SimpleDDL
              id="select_kode_ddl"
              box="search"
              name="ddl"
              label={`Kode ${this.title}`}
              value={ddl}
              options={ddlData}
              mandatory
              errorMessage={error.ddl}
              onChange={(value, {name}) => this.handleDDLChange(name, value)}
            />

            <FlexView hAlignContent="right" style={{ marginTop: "16px" }}>
              <FlexView>
                <SimpleButton text="Cetak" onClick={this.handlePrint} />
              </FlexView>
            </FlexView>
          </ModalContainer>
        }
      />
    );
  }
}

PaymentReportFilterModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClickClose: PropTypes.func.isRequired,
  startDateName: PropTypes.string.isRequired,
  startDate: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(Date),
  ]),
  endDateName: PropTypes.string.isRequired,
  endDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  ddl: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onValueChange: PropTypes.func.isRequired,
  ddlData: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.string,
    })
  ),
  onPrint: PropTypes.func.isRequired,
  type: PropTypes.oneOf(['bank', 'cash']),
};

PaymentReportFilterModal.defaultProps = {
  startDate: null,
  endDate: null,
  ddl: null,
  ddlData: [],
  type: null
};

export default PaymentReportFilterModal;
